module.exports = __webpack_public_path__ + "img/xzc.5c43b6c5.svg";